
import 'bootstrap/dist/css/bootstrap.min.css';
import '@aws-amplify/ui-react/styles.css';
import '../../App.css';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { Avatar, Image, SearchField, SelectField } from '@aws-amplify/ui-react';
import 'material-symbols';
import { Dropdown } from 'react-bootstrap';
import { Button as AmplifyButton } from '@aws-amplify/ui-react';
import { forwardRef } from 'react';


export const AuthAppNavBar = ({ user, searchText, onSearchTextChanged, language, onLanguageChanged, signOut }) => {
    const CustomToggle = forwardRef(({ children, onClick }, ref) => (
        <div ref={ref}
            onClick={(e) => {
                e.preventDefault()
                onClick(e)
            }}>
            {children}
        </div>
    ))
    return (
        <Navbar sticky="top" expand="lg" className="bg-body-tertiary w-100">
            <Container fluid={true}>
                <Navbar.Brand href="/">
                    <div className='d-flex align-item-center'>
                        <Image src="/logo192.png" style={{ maxHeight: '2.5rem' }}></Image>
                        <span className='brand'>Liftolog</span>
                    </div>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        <Nav.Link as={Link} to="/dashboard">Dashboard</Nav.Link>
                        <Nav.Link as={Link} to="/exercises">Exercises</Nav.Link>
                        <Nav.Link as={Link} to="/catalog">Catalog</Nav.Link>
                    </Nav>
                    <SearchField
                        value={searchText}
                        onChange={(e) => onSearchTextChanged(e.target.value)}
                        onClear={() => onSearchTextChanged("")}
                        className='w-100'>
                    </SearchField>
                    {user &&
                        <div className='d-none d-lg-block'>
                            <div className='d-flex align-items-center '>
                                <SelectField
                                    label="Language"
                                    className='mx-1 '
                                    descriptiveText="Select UI Language"
                                    labelHidden={true}
                                    value={language}
                                    onChange={(e) => onLanguageChanged(e.target.value)}
                                    style={{ minWidth: '10rem' }}
                                >
                                    <option value="en">English</option>
                                    <option value="ru">Russian</option>
                                </SelectField>
                                <AmplifyButton as={Link} to="/buddies">
                                    <span className="material-symbols-outlined">
                                        diversity_3
                                    </span>
                                    <span className='ms-1'>Buddies</span>
                                </AmplifyButton>
                                <Dropdown className='ms-2 ' drop='start'>
                                    <Dropdown.Toggle
                                        as={CustomToggle}
                                        id="dropdown-user-menu">
                                        <Avatar size='large'></Avatar>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className='mt-5'>
                                        <Dropdown.Item as={Link} to="/user-profile">User Profile</Dropdown.Item>
                                        <Dropdown.Item onClick={() => signOut()}>Sign out</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        </div>
                    }
                </Navbar.Collapse>
            </Container>
        </Navbar>
    )
}